import { post } from "./base";

export function syncEvents(accessToken) {
  return post("rag/sync_events", { accessToken });
}

export function queryEvents(accessToken, question) {
  return post("rag/query_events", { 
    accessToken,
    jsonBody: { question }
  });
}
